import { render, staticRenderFns } from "./ex.vue?vue&type=template&id=987a7216&scoped=true&"
import script from "./ex.vue?vue&type=script&lang=js&"
export * from "./ex.vue?vue&type=script&lang=js&"
import style0 from "./ex.vue?vue&type=style&index=0&id=987a7216&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987a7216",
  null
  
)

export default component.exports